<template>
  <div
    :style="{ 'z-index': getPopupZindex }"
    :class="{ 'reservations-cart-popup-overlay': true, 'is-visible': isVisible, 'block-buttons': allReservationsHaveStatus }">
    <div class="reservations-cart-popup">
      <a
        href="#"
        class="reservations-cart-popup-close"
        @click.prevent="closePopup">
        &times;
      </a>

      <div class="reservations-cart-popup-header">
        <h2>
          {{ $t('reservationsCartPopup.title') }}
        </h2>

        <div class="reservations-cart-popup-buttons">
          <btn
            v-if="userCanAddReservation && !allReservationsHaveStatus"
            :type="acceptInProgress ? 'loader success with-icon' : 'success with-icon'"
            @click.native="acceptAll"
            :disabled="acceptInProgress || rejectInProgress"
            :iconName="!acceptInProgress ? 'ok-circle' : 'loader'"
            iconColor="color-light">
            {{ $t('reservationsCartPopup.acceptAll') }}
          </btn>

          <btn
            v-if="userCanAddReservation && !allReservationsHaveStatus"
            :type="rejectInProgress ? 'loader danger with-icon' : 'danger with-icon'"
            @click.native="rejectAll"
            :disabled="acceptInProgress || rejectInProgress"
            :iconName="!rejectInProgress ? 'cross-circle' : 'loader'"
            iconColor="color-light">
            {{ $t('reservationsCartPopup.rejectAll') }}
          </btn>
        </div>
      </div>

      <div class="reservations-cart-popup-list">
        <reservation
          v-for="(reservationData, index) of reservationsData"
          :reservationData="reservationData"
          :key="'rcp-' + index"
          :showContact="false"
          :showStatusColors="true"
          :showStatus="true"
          :blockChangeActions="allReservationsHaveStatus || acceptInProgress || rejectInProgress"
          :indexOnList="index"
          :isBlock="isMobile || isTablet"
          :daysMode="reservationData.type === 1" />
      </div>

      <btn
        type="full-width danger"
        @click.native="closePopup">
        {{ $t('common.ui.close') }}
      </btn>
    </div>
  </div>
</template>

<script>
import Configuration from './../mixins/Configuration';
import ErrorUtils from './../helpers/ErrorUtils.js';
import PopupZindex from './../mixins/PopupZindex';
import Reservation from './Reservation';
import Responsive from './../mixins/Responsive';
import UserTypes from './../mixins/UserTypes';

export default {
  name: 'reservations-cart-popup',
  mixins: [
    Configuration,
    PopupZindex,
    Responsive,
    UserTypes
  ],
  components: {
    'reservation': Reservation
  },
  computed: {
    allReservationsHaveStatus () {
      return this.reservationsData.filter(reservation => reservation.status === 1).length === 0;
    }
  },
  watch: {
    allReservationsHaveStatus: function (newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.$bus.$emit('notification-display', {
          type: 'success',
          message: this.$t('reservationsCartPopup.emailNotificationsSent')
        });
      }
    }
  },
  data () {
    return {
      isVisible: false,
      reservationsData: [],
      rejectInProgress: false,
      acceptInProgress: false,
      cartID: 0
    };
  },
  mounted () {
    this.$bus.$on('show-reservations-cart-popup', this.showPopup);
  },
  methods: {
    showPopup (data) {
      this.isVisible = true;
      this.reservationsData = data.inquiries;
      this.cartID = data.cartID;
      this.increasePopupZindex();
    },
    closePopup () {
      this.isVisible = false;
      this.removePopupZindex();
    },
    acceptAll () {
      this.acceptInProgress = true;

      this.$http.post('/panel/general/set-cart-status', {
        cart_id: this.cartID,
        status: 3
      }).then(response => {
        this.acceptInProgress = false;

        if (response.data && response.data.data) {
          this.updateStatuses(response.data.data, false);
          this.showWarningIfNecessary();
        }
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/general/set-cart-status', this.$router, this.$bus, this.acceptAll.bind(this));
        this.acceptInProgress = false;
      });
    },
    rejectAll () {
      if (this.$store.state.config.company.waiting_list) {
        this.$bus.$emit('confirm-display', {
          title: this.$t('reservationsCartPopup.rejectPopupTitle'),
          desc: this.$t('reservationsCartPopup.rejectPopupDesc'),
          cancelLabel: this.$t('reservationsCartPopup.rejectPopupCancelButton'),
          cancelClick: this.rejectCartReservations.bind(this, 4, true),
          okLabel: this.$t('reservationsCartPopup.rejectPopupOkButton'),
          okClick: this.rejectCartReservations.bind(this, 6, true)
        });
      } else {
        this.rejectCartReservations(4);
      }
    },
    rejectCartReservations (statusToSet) {
      this.rejectInProgress = true;

      this.$http.post('/panel/general/set-cart-status', {
        cart_id: this.cartID,
        status: statusToSet
      }).then(response => {
        this.rejectInProgress = false;

        if (response.data && response.data.data) {
          this.updateStatuses(response.data.data, true);
        }
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/general/set-cart-status', this.$router, this.$bus, this.rejectAll.bind(this));
        this.rejectInProgress = false;
      });
    },
    updateStatuses (data, rejectMode) {
      let statuses = {};
      let statusToSet = rejectMode ? 4 : 3;

      for (let i = 0; i < data.length; i++) {
        let item = data[i];

        if (item.success === 1) {
          statuses[item.inquiry_id] = statusToSet;
        }
      }

      for (let i = 0; i < this.reservationsData.length; i++) {
        let id = this.reservationsData[i].id;

        if (statuses[id]) {
          this.reservationsData[i].status = statusToSet;
        }
      }

      let waitingInquiries = this.reservationsData.filter(reservation => reservation.status === 1);

      if (!waitingInquiries.length) {
        this.$store.commit('global/removeInquiriesCart', this.cartID);
      }
    },
    showWarningIfNecessary () {
      if (!this.allReservationsHaveStatus) {
        this.$bus.$emit('alert-display', {
          title: this.$t('reservationsCartPopup.manualAcceptRequiredTitle'),
          desc: this.$t('reservationsCartPopup.manualAcceptRequiredDesc'),
          okLabel: this.$t('common.ui.ok'),
          okClick: () => true,
          isDanger: false
        });
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-reservations-cart-popup', this.showPopup);
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.reservations-cart-popup {
  background: $color-light;
  border-radius: $border-radius-small;
  left: 50%;
  max-height: 80vh;
  padding-bottom: 4rem;
  position: fixed;
  top: 50%;
  transform: translateX(-50%) translateY(-45%);
  transition: transform .25s ease-out;
  width: 980px;
  will-change: transform;

  & > .button {
    display: none;
  }

  &-buttons {
    align-items: center;
    display: flex;
    margin-left: auto;

    /deep/ .button {
      .icon {
        position: relative;
        top: 1px;
      }

      &:first-child {
        .icon {
          top: -1px;
        }
      }
    }
  }

  &-overlay {
    background: rgba(0, 0, 0, .5);
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: opacity .25s ease-out;
    width: 100%;
    will-change: opacity;

    &.is-visible {
      opacity: 1;
      pointer-events: auto;

      .reservations-cart-popup {
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }

  &-header {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    height: 75px;
    padding-top: 1rem;
    width: calc(100% - 80px);

    & + .reservations-cart-popup-list {
      height: calc(100% - 215px);
    }

    h2 {
      align-items: center;
      display: flex;
      font-weight: 400;
      margin: 0;
    }
  }

  &-list {
    max-height: calc(80vh - 160px);
    margin: 0 auto;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 2rem;
    position: relative;
    width: calc(100% - 40px);
  }

  &-close {
    background: $color-danger;
    border-radius: 50%;
    color: $color-light;
    font-size: 3.6rem;
    font-weight: bold;
    height: 3.6rem;
    line-height: 3.5rem;
    position: absolute;
    right: -1.8rem;
    text-align: center;
    top: -1.8rem;
    width: 3.6rem;
  }
}

@media (max-width: 1040px) {
  .reservations-cart-popup {
    border-radius: 0;
    height: 100%;
    max-height: 100%;
    left: 0;
    top: 0;
    transform: none!important;
    width: 100vw;

    & > .button {
      border-radius: 0;
      bottom: 0;
      display: block;
      left: 0;
      position: absolute;
      width: 100%;
    }

    &-close {
      display: none;
    }

    &-header {
      align-items: center;
      margin: 0 1rem;
      width: calc(100% - 2rem);
    }

    &-list {
      align-items: flex-start;
      display: flex;
      flex-wrap: wrap;
      height: calc(100% - 80px)!important;
      margin: 0;
      max-height: calc(100% - 80px)!important;
      padding: 0;
      width: calc(100%);

      .reservation {
        margin: 1rem;
        max-width: calc((100% / 3) - 2rem);
        width: calc((100% / 3) - 2rem);
      }
    }
  }
}

@media (max-width: 720px) {
  .reservations-cart-popup {
    &-list {
      .reservation {
        max-width: calc((100% / 2) - 2rem);
        width: calc((100% / 2) - 2rem);
      }
    }
  }
}

@media (max-width: 520px) {
  .reservations-cart-popup {
    &-list {
      .reservation {
        max-width: 100%;
        width: 100%;
      }
    }
  }
}

@media (max-width: 580px) {
  .reservations-cart-popup {
    &-buttons {
      margin-top: 1rem;
      width: 100%;

      .button {
        justify-content: center;
        width: 50%;
      }
    }

    &-list {
      max-height: calc(100% - 100px);
      margin-top: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ReservationsCartPopup.vue